import { mapInboxData } from '../utils';
import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  client: null,
  totalCount: 0,
  error: null,
};

const clientInbox = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_CLIENT_FOR_CLIENT_INBOX:
      return {
        ...state,
        client: payload,
      };
    case actionTypes.CLEAR_CLIENT_FOR_CLIENT_INBOX:
      return {
        ...state,
        client: null,
      };
    case actionTypes.CLIENT_INBOX_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.CLIENT_INBOX_SUCCESS:
      return {
        ...state,
        data: [...state.data.concat(mapInboxData(payload.result_hits))],
        totalCount: payload.total,
        isLoading: false,
      };
    case actionTypes.CLIENT_INBOX_ERROR:
      return {
        ...state,
        error: payload,
        isLoading: false,
      };
    case actionTypes.CLIENT_INBOX_RESET:
      return {
        ...state,
        data: [],
        totalCount: 0,
      };
    default:
      return state;
  }
};

export default clientInbox;
